
<template>
  <Loader v-if="loader" />

  <div class="card">
      <div class="formgrid grid ">
          <div class="field col-12 md:col-3">
              <label>Distributore</label>
              <Dropdown v-model="selectedDistributore" :options="distributori" optionLabel="name" placeholder="Seleziona distributori" :class="['inputfield w-full',{'p-invalid': validationErrors.distributore && submitted}]" />
              <div v-show="validationErrors.distributore && submitted" class="p-error">Seleziona distributore.</div>
          </div>
          <div class="field col-12 md:col-3">
              <label>Emissione</label>
              <Calendar v-model="data_emissione" :showIcon="true" view="year" dateFormat="yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data_emissione && submitted}]" />
              <div v-show="validationErrors.data_emissione && submitted" class="p-error">Seleziona anno.</div>
          </div>
          <div class="field col-12 md:col-3">
              <label>Competenza</label>
              <Calendar v-model="data_competenza" :showIcon="true" view="year" dateFormat="yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data_competenza && submitted}]" />
              <div v-show="validationErrors.data_competenza && submitted" class="p-error">Seleziona anno.</div>
          </div>
          <div class="field col-12 md:col-3 flex align-items-end justify-content-center">
              <Button label="Cerca" icon="pi pi-search" iconPos="right" class="w-full" @click="searchData" />
          </div>
      </div>
  </div>

  <div class="card">
      <DataTable ref="dt" :value="invoices" :paginator="true" :rows="10" :filters="filters" 
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
          currentPageReportTemplate="{first} a {last} di {totalRecords}">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                   <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                   <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                </div>
            </div>
          </template>
          
          <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
          <Column field="tipo_documento" header="Tipo" :sortable="true"></Column>
          <Column field="numero" header="Fattura" :sortable="true"></Column>
          <Column field="nota_credito" header="Nota Credito" :sortable="true">
          <template #body="{data}">
              {{data.nota_credito ? 'SI' : 'NO'}}     
            </template>
          </Column>
          <Column field="data_emissione" header="Data emissione" :sortable="true"></Column>
          <Column field="competenza_da" header="Competenza da" :sortable="true"></Column>
          <Column field="competenza_a" header="Competenza a" :sortable="true"></Column>
          <Column field="quantita" header="Quantita Kwh" :sortable="true"></Column>
          <Column field="id_sdi" header="Code SDI" :sortable="true"></Column>
          <Column field="totale_imponibile_distributore" header="Imponibile Dist." :sortable="true">
            <template #body="{data}">
              {{data.totale_imponibile_distributore.toFixed(2)}}     
            </template>
          </Column>
          <Column field="totale_imponibile_sdi" header="Imponibile Sdi" :sortable="true">
            <template #body="{data}">
              {{data.totale_imponibile_sdi.toFixed(2)}}     
            </template>
          </Column>
          <Column field="company" header="Azienda" :sortable="true"></Column>
          <Column field="fornitore" header="Fornitore" :sortable="true"></Column>
      </DataTable>
  </div>

</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
    setup() {

      const dt = ref();
      const loader = ref(false)
      const invoices = ref([]);
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const data_emissione = ref();
      const data_competenza = ref();
      const distributori = ref([]);
      const selectedDistributore = ref('')
      const validationErrors = ref({})
      const submitted = ref(false)

      onMounted(() => {       
          getDistributori()              
      })
      const searchData = () => {
        submitted.value = true;
        if (validateData()) {
          loader.value = true
          service.getBilancioFattAcquisto(
            moment(data_emissione.value).format('YYYY'),
            moment(data_competenza.value).format('YYYY'),
            selectedDistributore.value.name,
          ).then((res) => {
            invoices.value = res.items      
          }).finally(() => {
              loader.value = false
          })
        }
      }

      const getDistributori = () =>{
        service.getDistributori().then((res) => {
          distributori.value = res.items
        })
      }

      const validateData = () =>{
          if (data_emissione.value == null)
            validationErrors.value['data_emissione'] = true;
          else 
            delete validationErrors.value['data_emissione'];
          
          if (data_competenza.value == null)
            validationErrors.value['data_competenza'] = true;
          else 
            delete validationErrors.value['data_competenza'];

        if (selectedDistributore.value == '')
            validationErrors.value['distributore'] = true;
          else 
            delete validationErrors.value['distributore'];
    
        return !Object.keys(validationErrors.value).length;
      }

      const exportCSV = () => {
        dt.value.exportCSV();
      };


      return { 
        dt,
        invoices,
        loader, 
        filters, 
        data_emissione,
        data_competenza,
        distributori,
        selectedDistributore,
        searchData,
        exportCSV,
        validationErrors,
        submitted
      }
  }
}
</script>

<style scoped>

</style>
